/*       */

import React, { PureComponent } from 'react';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { DateTimePicker, DatePicker } from '@mic3/platform-ui';
import { set } from 'app/utils/immutable/Immutable';

class DateTime extends PureComponent {

    state = {
        initDate: null,
        isOpen: false,
        key: new Date(),
        lockedValue: undefined,
    }

    @bind
    @memoize()
    getDialogProps(DialogProps) {
        return set(DialogProps, 'style.zIndex', 3000);
    }

    render() {
        const { DialogProps, dateOnly, ...rest } = this.props;
        const newDialogProps = this.getDialogProps(DialogProps);
        const { isOpen, initDate, lockedValue } = this.state;
        const displayValue = isOpen
            ? (lockedValue !== undefined ? lockedValue : rest.value) || initDate
            : rest.value || initDate;
        const PickerComponent = dateOnly ? DatePicker : DateTimePicker;
        return <PickerComponent
            DialogProps={newDialogProps}
            {...rest}
            value={displayValue}
            key={this.state.key}
            open={isOpen}
            onOpen={() => {
                this.setState({
                    key: new Date(),
                    isOpen: true,
                    initDate: new Date(),
                    lockedValue: rest.value !== undefined ? rest.value : null,
                })
            }}
            onClose={() => {
                this.setState({
                    isOpen: false,
                    initDate: null,
                    lockedValue: undefined,
                })
            }}
        />;
    }
}

export default DateTime;
